import { useEffect, useState } from 'react'
import { getClientJobSitesV2, type ClientJobSiteItemV2 } from '@/lib/api/v2/clients'

export function useClientJobSitesV2(params: { customerId: string | null; take?: number }) {
  const [jobSites, setJobSites] = useState<ClientJobSiteItemV2[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    let mounted = true

    /* eslint-disable react-hooks/set-state-in-effect */
    if (!params.customerId) {
      setJobSites([])
      setIsLoading(false)
      setError(null)
      return
    }

    setIsLoading(true)
    setError(null)
    /* eslint-enable react-hooks/set-state-in-effect */

    getClientJobSitesV2({ customerId: params.customerId, take: params.take })
      .then((items) => {
        if (!mounted) return
        setJobSites(items)
      })
      .catch((e) => {
        if (!mounted) return
        setError(e as Error)
        setJobSites([])
      })
      .finally(() => {
        if (!mounted) return
        setIsLoading(false)
      })

    return () => {
      mounted = false
    }
  }, [params.customerId, params.take])

  return { jobSites, isLoading, error }
}
